import React, { memo } from 'react';

/**
 * App Footer
 *
 * @example
 * <Footer />
 */
function Footer() {
  return (
    <footer className="footer">
      Built with ❤ by Checkmarx's Research team
    </footer>
  );
}
export default memo(Footer);
